import moment from 'moment';

export const dateValidation = value => {
  if (!value) {
    return false;
  }
  const parsedDate = moment(value, 'MM/DD/YYYY', true);

  return parsedDate.isValid();
};
